import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=9746e1bc&scoped=true"
import script from "./bottom.vue?vue&type=script&lang=js"
export * from "./bottom.vue?vue&type=script&lang=js"
import style0 from "./bottom.vue?vue&type=style&index=0&id=9746e1bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9746e1bc",
  null
  
)

export default component.exports